import { inToPx } from '../utils';

export const GRID_PRINT_EDITION = {
  GRID_WIDTH: inToPx(0.25),
  GRID_SIZE: 69,
  HORIZONTAL: 68.5,
  VERTICAL: 44.5,
  GRID_MARGIN: 14
};
export const GRID_DIGITAL_EDITION = {
  GRID_WIDTH: 30,
  GRID_SIZE: 65,
  HORIZONTAL: 64,
  VERTICAL: 36
};
